import type { Plan } from '../types';

export function isPremiumPlan(plan?: Plan | string | null): boolean {
  return plan === 'premium' || plan === 'premium_monthly' || plan === 'premium_annual' || plan === 'premium_annualy';
}

export function planLabel(plan?: Plan | string | null): string {
  if (plan === 'premium_annual' || plan === 'premium_annualy') return 'Premium Annuale';
  if (plan === 'premium' || plan === 'premium_monthly') return 'Premium Mensile';
  return 'Gratuito';
}
